import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Link } from 'gatsby';
import Layout from '../../../components/layout';
import { dates } from '../../../components/dates';
import { LinkResolution } from '../../../components/resolution';
import { MinutesHeader, minutes_type, minutes_status } from '../../../components/minutes';
import { r as amtrak_cascades } from '../../resolutions/2021/Amtrak-Cascades-long-range-plan.js';
export const resolutions = [amtrak_cascades];
export const date = '2021-01-13T18:30-08:00';
export const remote = true;
export const status = minutes_status.placeholder;
export const type = minutes_type.general;
export const m = {
  date,
  remote,
  status,
  type
};
export const {
  prev_path
} = dates(date);
export const _frontmatter = {};
const layoutProps = {
  resolutions,
  m,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Layout mdxType="Layout">
	<MinutesHeader m={m} mdxType="MinutesHeader" />
	<dl className="agenda">
		<dt>6:00</dt><dd>Sign In</dd>
		<dt>6:30</dt><dd>Call To Order</dd>
		<dt>6:31</dt><dd><Link to="/pledge-of-allegiance" className="link" mdxType="Link">Pledge of Allegiance</Link></dd>
		<dt>6:33</dt><dd><Link to={prev_path} className="link" mdxType="Link">Approve of previous meeting's minutes</Link></dd>
		<dd>Ratification of committee chairs</dd>
		<dd>Resolution to fund and prioritize Amtrak Cascades long-range plan (presented by Lael White and Thomas White)</dd>
		<dt>7:00</dt><dd><Link to="/resolutions" className="link" mdxType="Link">Resolutions</Link>
			<ul className="menu">
				{resolutions.map(r => <li><LinkResolution r={r} status={true} mdxType="LinkResolution" /></li>)}
			</ul>
		</dd>
		<dd>Presentation from Recall Adam Fortney campaign</dd>
		<dt>8:20</dt><dd>New Business</dd>
		<dt>8:25</dt><dd>Good of the Order</dd>
		<dt>8:30</dt><dd>Adjourn</dd>
	</dl>
      <pre>
        <a href="https://zoom.us/webinar/register/WN_ThVg1TulScagzVlR1RQM5A">Zoom meeting</a> — Register in advance for this meeting<br />
      </pre>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      